"use strict";
var _a, _b, _c;
Object.defineProperty(exports, "__esModule", { value: true });
const windowPlaudit = (_a = window.plaudit) !== null && _a !== void 0 ? _a : (window.plaudit = {});
const windowPlauditQueryLoop = (_b = windowPlaudit.queryLoop) !== null && _b !== void 0 ? _b : (windowPlaudit.queryLoop = {});
const plauditQueryLoopAPILoaded = (_c = windowPlauditQueryLoop.loaded) !== null && _c !== void 0 ? _c : (windowPlauditQueryLoop.loaded = new Promise(resolve => {
    if (windowPlauditQueryLoop.forms) {
        resolve();
    }
    else {
        const resolver = () => {
            resolve();
            document.removeEventListener('plauditQueryLoopAPILoaded', resolver);
        };
        document.addEventListener('plauditQueryLoopAPILoaded', resolver);
    }
}));
exports.default = plauditQueryLoopAPILoaded;
